import { render, staticRenderFns } from "./ParamsShare.vue?vue&type=template&id=5a38e410"
import script from "./ParamsShare.vue?vue&type=script&lang=js"
export * from "./ParamsShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports